import { useTheme } from '@emotion/react';
import { useSetAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Button } from '~/components/blocks';
import { invitationModalState } from '~/state/reception/atoms';

export const InvitationButton = () => {
  const theme = useTheme();
  const setInvitationModalState = useSetAtom(invitationModalState);

  const handleClick = useCallback(() => {
    setInvitationModalState((_state) => ({ ..._state, isOpen: true }));
  }, [setInvitationModalState]);
  return (
    <Button size="s" ml={theme.space.m} onClick={handleClick}>
      オンライン服薬指導申込コード
    </Button>
  );
};
